let postLogoutRedirectUri = "https://dmmtui-qa.carrier.com/";

export const appConfig = {
  api: {
    apiUrl: "https://qaecat.carrier.com/drawingmanager/api/",
    umDashboardNavigation: "https://www.carrierappshub.com/",
    translationApi:
      "https://translationservice.carrier.com/api/v1/",
  },
  loginConfig: {
    apiUrl: "https://api.carrierappshub1.com/",
    uiUrl: postLogoutRedirectUri,
  },
};
export default appConfig;
